import { GymTypes } from 'fitbeat.models';
import { CardioOrResistance, Exercise, ExerciseFormat } from '../../../entities/exercise';
import { WorkoutSettings } from '../../../entities/user/workoutsettings';
import { ExerciseSelection } from '../../../entities/workout/exerciseselection';
import { SessionSequence, UserExerciseSession } from '../../../entities/workoutsession';
import { IExerciseRepository } from '../../../persistence';
import { SpecialFormatExerciseSelector } from './SpecialFormatExerciseSelector';

export class PauseBreakExerciseSelector {
    public static async getBreaksForToday(
        exerciseRepository: IExerciseRepository, gymType: GymTypes, date: Date, instructor?: string)
    : Promise<Exercise[][]> {
            const randomiseSelection = true;
            const allExercises = await exerciseRepository.getAll();
            const firstBreaksForToday =  SpecialFormatExerciseSelector.getRandomSetMatchingFormatAndBodyGroups(
                allExercises, gymType, date, Exercise.isPauseFormat, randomiseSelection, instructor);

            const allExercisesExFirstBreaks = allExercises.filter((e) => firstBreaksForToday.indexOf(e) === -1);
            const secondBreaksForToday =  SpecialFormatExerciseSelector.getRandomSetMatchingFormatAndBodyGroups(
                allExercisesExFirstBreaks, gymType, date, Exercise.isPauseFormat, randomiseSelection, instructor);

            const allExercisesExFirstAndSecBreaks
                = allExercisesExFirstBreaks.filter((e) => secondBreaksForToday.indexOf(e) === -1);
            const thirdBreaksForToday =  SpecialFormatExerciseSelector.getRandomSetMatchingFormatAndBodyGroups(
                allExercisesExFirstAndSecBreaks, gymType, date, Exercise.isPauseFormat, randomiseSelection, instructor);

            return [firstBreaksForToday, secondBreaksForToday, thirdBreaksForToday];
    }

    public static pauseExerciseSelection(session: UserExerciseSession,
                                         breaks: Exercise[][],
                                         workoutSettings: WorkoutSettings,
                                         gymType: GymTypes)
        : ExerciseSelection | undefined {

        if (!session.isPause) {
            return undefined;
        }
        const selection = ExerciseSelection.fromUserExerciseSession(session);
        selection.format = session.format;

        if (gymType === GymTypes.Home && breaks != null && breaks.length > 0) {

            // remove set of breaks from the list when we use it, so that the next break is different
            const breaksForThisStage = breaks.pop();
            if (breaksForThisStage == null) {
                throw Error('Should be able to pop from an array with length');
            }
            const exercise = SpecialFormatExerciseSelector.filterFirstExerciseForFormatAndBodyGroup(
                breaksForThisStage, selection, workoutSettings);

            // TODO adust format if settings have changed - see how we did it for warmups

            if (!exercise) {
                // fallback to hard coded!
                selection.exercise = PauseBreakExerciseSelector.pauseExerciseHardCodedVideos(
                    workoutSettings.cardioOrResistance, selection.format, gymType);
                return selection;
            }

            selection.exercise = exercise;
        } else {
            selection.exercise = PauseBreakExerciseSelector.pauseExerciseHardCodedVideos(
                    workoutSettings.cardioOrResistance, selection.format, gymType);
        }

        return selection;
    }

    public static getDefaultPauseVideoFileNameForHome(settings: WorkoutSettings) {
        return SessionSequence.getPauseVideoFileName(settings.cardioOrResistance, GymTypes.Home);;
    }

    public static pauseExerciseAtStartOfHome(settings: WorkoutSettings): Exercise {
        const exercise = new Exercise(
            'pause', 'pause', [], false,
            [settings.cardioOrResistance], [], [], [],
            [ExerciseFormat.PauseAtWorkoutStarting]);
        exercise.uniqueReferenceNumber = PauseBreakExerciseSelector.getDefaultPauseVideoFileNameForHome(settings);
        return exercise;
    }

    private static pauseExerciseHardCodedVideos(
        cardioOrResistance: CardioOrResistance, format: ExerciseFormat, gymType: GymTypes)
        : Exercise {

        const exercise = new Exercise('pause', 'pause', [], false,
            [cardioOrResistance], [], [], [],
            [format]);

        exercise.uniqueReferenceNumber = SessionSequence.getPauseVideoFileName(cardioOrResistance, gymType);
        return exercise;
    }

}
